import ScrollToTop from "react-scroll-to-top";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import LoginForm from "../components/LoginForm";
import Navbar from "../components/Navbar";

function Login() {
	return (
		<>
			<Navbar />
			<Hero image="/assets/hero/login.jpg" />
			<LoginForm />
			<Footer />
		</>
	);
}

export default Login;
